import React from 'react';
import { BiSolidStar } from 'react-icons/bi';
import { BsEnvelopePlusFill, BsFire, BsGraphUpArrow } from 'react-icons/bs';
import { FaBan, FaUserTie } from 'react-icons/fa';
import { IoMdSettings } from 'react-icons/io';
import { LuBoxes } from 'react-icons/lu';
import { MdOutlineDashboardCustomize, MdOutlineRestaurantMenu, MdOutlineAttachMoney, MdTrendingUp } from 'react-icons/md';
import { PiArmchairFill } from 'react-icons/pi';
import { RiHotelFill } from 'react-icons/ri';
import EggIcon from '../assets/images/egg.jpg';
import NonVegIcon from '../assets/images/non-veg.jpg';
import RasopsLogo from '../assets/images/rasops.png';

export const THEME = {
    colors: {
        primary: '#3EB075',
        secondary: '#08182d',
        white: '#ffffff',
        golden: '#FDFD96',
        gray: '#888',
        lightGreen: '#c5f2d8',
        textMuted: '#6B7280',
        cardShadow: '0 6px 16px rgba(0, 0, 0, 0.08)',
        dividerColor: '#E5E7EB'
    }
};

export const USER_ROLES = {
    hotelOwner: 'HOTEL_OWNER',
    hotelStaff: 'HOTEL_STAFF',
    foodCourtOwner: 'FOOD_COURT_OWNER',
    foodCourtShopOwner: 'FOOD_COURT_SHOP_OWNER',
    foodCourtStaff: 'FOOD_COURT_SHOP_STAFF'
};

export const MENU_STATUS = ['AVAILABLE', 'UNAVAILABLE'];
export const ORDER_STATUS = {
    pending: 'PENDING',
    prepared: 'PREPARED',
    served: 'SERVED',
    completed: 'COMPLETED',
    cancelled: 'CANCELLED'
};
export const TABLE_STATUS = ['OPEN', 'BOOKED'];
export const BUSINESS_TYPES = ['public_limited', 'private_limited'];
export const BUSINESS_CATEGORIES = ['food'];
export const BUSINESS_SUB_CATEGORIES = ['restaurant', 'food_court', 'catering'];

export const NOTIFICATION_ACTIONS = {
    ORDER_UPDATES: 'order_updated'
};

export const TITLES = {
    '/hotels': 'Hotels',
    '/invites': 'Invites',
    '/staff': 'Staff',
    '/dashboard': 'Dashboard',
    '/menu': 'Menu',
    '/tables': 'Tables',
    '/inventory': 'Inventory',
    '/orders': 'Orders',
    '/settings': 'Settings'
};

export const OWNER_TABS = [
    {
        order: 2,
        id: 'hotels',
        Icon: RiHotelFill,
        title: 'Hotels',
        path: '/hotels'
    },
    {
        order: 3,
        id: 'invites',
        Icon: BsEnvelopePlusFill,
        title: 'Invites',
        path: '/invites'
    },
    {
        order: 4,
        id: 'staff',
        Icon: FaUserTie,
        title: 'Staff',
        path: '/staff'
    }
];

export const HOTEL_STAFF_TABS = [
    {
        order: 1,
        id: 'dashboard',
        Icon: MdOutlineDashboardCustomize,
        title: 'Dashboard',
        path: '/dashboard'
    },
    {
        order: 5,
        id: 'menu',
        Icon: MdOutlineRestaurantMenu,
        title: 'Menu',
        path: '/menu'
    },
    {
        order: 6,
        id: 'tables',
        Icon: PiArmchairFill,
        title: 'Tables',
        path: '/tables'
    },
    {
        order: 7,
        id: 'inventory',
        Icon: LuBoxes,
        title: 'Inventory',
        path: '/inventory'
    },
    // {
    //     order: 7,
    //     id: 'activeOrders',
    //     Icon: IoFastFood,
    //     title: 'Active Orders',
    //     path: '/active'
    // },
    {
        order: 8,
        id: 'orders',
        Icon: MdOutlineAttachMoney,
        title: 'Orders',
        path: '/orders'
    }
];

export const FOOD_COURT_OWNER_TABS = [
    {
        order: 2,
        id: 'hotels',
        Icon: RiHotelFill,
        title: 'Hotels',
        path: '/hotels'
    },
    {
        order: 6,
        id: 'tables',
        Icon: PiArmchairFill,
        title: 'Tables',
        path: '/tables'
    },
    {
        order: 3,
        id: 'invites',
        Icon: BsEnvelopePlusFill,
        title: 'Invites',
        path: '/invites'
    }
];

export const FOOD_COURT_SHOP_OWNER_TABS = [
    {
        order: 1,
        id: 'dashboard',
        Icon: MdOutlineDashboardCustomize,
        title: 'Dashboard',
        path: '/dashboard'
    },
    {
        order: 3,
        id: 'invites',
        Icon: BsEnvelopePlusFill,
        title: 'Invites',
        path: '/invites'
    },
    {
        order: 5,
        id: 'menu',
        Icon: MdOutlineRestaurantMenu,
        title: 'Menu',
        path: '/menu'
    },
    {
        order: 5,
        id: 'inventory',
        Icon: LuBoxes,
        title: 'Inventory',
        path: '/inventory'
    },
    // {
    //     order: 7,
    //     id: 'activeOrders',
    //     Icon: IoFastFood,
    //     title: 'Active Orders',
    //     path: '/active'
    // },
    {
        order: 8,
        id: 'orders',
        Icon: MdOutlineAttachMoney,
        title: 'Orders',
        path: '/orders'
    },
    {
        order: 4,
        id: 'staff',
        Icon: FaUserTie,
        title: 'Staff',
        path: '/staff'
    }
];

export const FOOD_COURT_SHOP_STAFF_TABS = [
    {
        order: 1,
        id: 'dashboard',
        Icon: MdOutlineDashboardCustomize,
        title: 'Dashboard',
        path: '/dashboard'
    },
    {
        order: 5,
        id: 'menu',
        Icon: MdOutlineRestaurantMenu,
        title: 'Menu',
        path: '/menu'
    },
    {
        order: 6,
        id: 'inventory',
        Icon: LuBoxes,
        title: 'Inventory',
        path: '/inventory'
    },
    // {
    //     order: 7,
    //     id: 'activeOrders',
    //     Icon: IoFastFood,
    //     title: 'Active Orders',
    //     path: '/active'
    // },
    {
        order: 8,
        id: 'orders',
        Icon: MdOutlineAttachMoney,
        title: 'Orders',
        path: '/orders'
    }
];

export const COMMON_TABS = [
    {
        order: 9,
        id: 'settings',
        Icon: IoMdSettings,
        title: 'Settings',
        path: '/settings'
    }
];

export const VERIFICATION_ROUTE = ['/verify', '/reset', '/signup'];

export const FIELD_CLASS = 'col-md-6 col-12 my-2';

export const EXPIRED_INVITE_DATA = {
    firstName: 'EXPIRED',
    lastName: 'EXPIRED',
    password: 'expired@1234',
    phoneNumber: 1111111111
};

export const ImageErrorFallback = (e) => {
    e.target.onerror = null;
    e.target.src = RasopsLogo;
    e.target.style.objectFit = 'contain';
    e.target.style.padding = '10px';
};

export const BILLING_TYPE = [{
    label: 'Pre Paid',
    value: 'PRE_PAID'
}, {
    label: 'Post Paid',
    value: 'POST_PAID'
}];

export const activeOrdersSearchOptions = [
    { value: 'tokenId', label: 'Token ID' },
    { value: 'tableId', label: 'Table ID' }
];

export const PAYMENT_ACTIVATION_STATUS = {
    business: 'BUSINESS',
    stakeholder: 'STAKEHOLDER',
    bank: 'BANK',
    done: 'DONE'
};

export const HOTEL_TYPES = [{
    label: 'Restaurant',
    value: 'restaurant'
}, {
    label: 'QSR',
    value: 'qsr'
}, {
    label: 'Food Court Outlet',
    value: 'food-court-outlet'
}];

export const INVENTORY_UNIT = [
    { label: 'Gram (g)', value: 'g' },
    { label: 'Milliliter (ml)', value: 'ml' },
    { label: 'Piece (pc)', value: 'pc' },
    { label: 'Packet (pk)', value: 'pk' },
    { label: 'Dozen (dz)', value: 'dz' }
];

export const SERVICE_TYPES = {
    DINE_IN: 'DINE_IN',
    TAKEAWAY: 'TAKEAWAY'
};

export const foodTypes = {
    veg: 'VEG',
    nonveg: 'NON_VEG',
    egg: 'EGG'
};

export const icons = {
    nonveg: NonVegIcon,
    egg: EggIcon
};

export const RATING_OPTIONS = [
    { label: 'All Ratings', value: '' },
    { label: '3.0+', value: 3 },
    { label: '4.0+', value: 4 },
    { label: '4.5+', value: 4.5 }
];

export const SORT_OPTIONS = [
    {
        label: 'No Filter',
        value: '',
        icon: <FaBan />
    },
    {
        label: 'Best Seller',
        value: 'BEST_SELLER',
        icon: <BsFire />
    },
    {
        label: 'Today\'s Best Seller',
        value: 'TOP_RATED',
        icon: <BiSolidStar />
    },
    {
        label: 'Price: Low → High',
        value: 'PRICE_ASC',
        icon: <BsGraphUpArrow />
    },
    {
        label: 'Price: High → Low',
        value: 'PRICE_DESC',
        icon: (<MdTrendingUp style={{ transform: 'rotate(180deg)' }} />)
    }
];
